import React, { useContext } from 'react'
import { StateContext } from './Context';
import './IndividualNote.css'
import { useHistory } from 'react-router-dom'


function IndividualNote() {
    let history = useHistory()

    const { savedTitlesObj, savedNotesObj, clickedTitleObj } = useContext(StateContext);
    const [savedTitles, setSavedTitles] = savedTitlesObj;
    const [savedNotes, setSavedNotes] = savedNotesObj;
    const [clickedTitle, setClickedTitle] = clickedTitleObj;


    const handleDelete = (i) => {
        console.log(i);


        let newSavedTitles = savedTitles.filter((item, index) => index != i)
        setSavedTitles(newSavedTitles)

        let newSavedNotes = savedNotes.filter((item, index) => index != i)
        setSavedNotes(newSavedNotes)
    }

    return (
        <>
            <h2 className="your-notes-h2" >YOUR NOTES</h2>
            <hr className='hr-note' />
            {
                savedTitles.map((n, i) => (

                    <div className="title-el" key={i} >
                        <p onClick={() => {
                            setClickedTitle(n.title)
                            history.push(`/noteview/${i}`)
                        }} > {n.title} </p>

                        <span onClick={() => handleDelete(i)} ><i class="fas fa-trash-alt"></i></span>
                    </div>
                ))
            }
        </>
    )
}

export default IndividualNote;
